import { Component } from "@angular/core";
import { MatDialogRef }      from "@angular/material/dialog";
import { Iso639_1 } from "../../../_model/Language";
import { PHBGlobals } from "../../../_config/config";
import { MatButtonModule } from "@angular/material/button";
import { TranslatePipe } from "../../pipes/translate";

@Component({
	selector: "app-changed-zoom",
	templateUrl: "./changed-zoom.component.html",
	styleUrls: ["./changed-zoom.component.scss"],
	standalone: true,
	imports: [
		TranslatePipe,
		MatButtonModule
	]
})
export class ChangedZoomComponent {

	get systemLanguage(): Iso639_1 {
		return PHBGlobals.systemLanguage;
	}


	constructor(protected dialogRef: MatDialogRef<ChangedZoomComponent>) {
	}

	acceptAndClose() {
		this.dialogRef.close('restart');
	}

	close() {
		this.dialogRef.close();
	}

}
